module.exports = __webpack_public_path__ + "static/media/tooltip.1b52d399.svg";


//////////////////
// WEBPACK FOOTER
// ./src/views/EditProfile/tooltip.svg
// module id = 348
// module chunks = 0